// src/hooks/useLocations.ts
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetcher } from "../lib/apiClient";
import type { MapForm } from "@/schemas/map/mapFormSchema";

export function useMapConfig() {
  return useQuery({
    queryKey: ["map"],
    queryFn: (): Promise<MapForm> => fetcher("/api/map/config"),
  });
}

export function useMapConfigUpdate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: MapForm) =>
      fetcher("/api/map/config", {
        method: "PUT",
        body: JSON.stringify(data),
      }),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ["map-config"] }),
  });
}

// export function useMap() {
//   return useQuery({
//     queryKey: ["map"],
//     queryFn: () => fetcher("/api/map"),
//   });
// }

// export function useUpdateMap() {
//   const queryClient = useQueryClient();
//   return useMutation({
//     mutationFn: (data: { latitude: number; longitude: number }) =>
//       fetcher("/api/map/locations", {
//         method: "POST",
//         body: JSON.stringify(data),
//       }),
//     onSuccess: () =>
//       queryClient.invalidateQueries({ queryKey: ["map-settings"] }),
//   });
// }

// ////

// export const useMapSettings = () => {
//   return useQuery({
//     queryKey: ["map-settings"],
//     queryFn: (): Promise<SettingsQuery> => fetcher("/api/map/settings"),
//   });
// };

// export function addMapLocation() {
//   const queryClient = useQueryClient();
//   return useMutation({
//     mutationFn: (data: { latitude: number; longitude: number; name: string }) =>
//       fetcher("/api/map/locations", {
//         method: "POST",
//         body: JSON.stringify(data),
//       }),
//     onSuccess: () =>
//       queryClient.invalidateQueries({ queryKey: ["map-settings"] }),
//   });
// }

// export function useUpdateMapSettings() {
//   const queryClient = useQueryClient();
//   return useMutation({
//     mutationFn: (data: {
//       zoom: number[];
//       darkMapUrl: string;
//       lightMapUrl: string;
//       satelliteMapUrl: string;
//       selectedLocation: number;
//       showSatellite: boolean;
//     }) =>
//       fetcher(`/api/map/settings`, {
//         method: "PUT",
//         body: JSON.stringify(data),
//       }),
//     onSuccess: () =>
//       queryClient.invalidateQueries({ queryKey: ["map-settings"] }),
//   });
// }

// export function useToogleSatellite() {
//   const queryClient = useQueryClient();
//   return useMutation({
//     mutationFn: (data: { showSatellite: boolean }) =>
//       fetcher(`/api/map/settings/satellite`, {
//         method: "PUT",
//         body: JSON.stringify(data),
//       }),
//     onSuccess: () =>
//       queryClient.invalidateQueries({ queryKey: ["map-settings"] }),
//   });
// }

// export function useDeleteSelectedMap() {
//   const queryClient = useQueryClient();
//   return useMutation({
//     mutationFn: (selectedId: number) =>
//       fetcher(`/api/map/settings?id=${selectedId}`, {
//         method: "DELETE",
//       }),
//     onSuccess: () =>
//       queryClient.invalidateQueries({
//         queryKey: ["map-settings"],
//       }),
//   });
// }
